import React from 'react'
import "./BlogPost.css";

import rm from "../../Assets/b67/rm.jpg"

function Blog67() {
    return (
        <div className='container-fluid my-5'>
            <div className='row mb-5'>
                <div className='col blog-text text-center'>
                    <h1>Happy Ramadan! 🌙</h1>
                    <h6>February 18, 2026 at 12:00 PM</h6>
                </div>
            </div>

            <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
                    <img src={rm} className="blog-img" alt="..." />
                </div>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
                    <p>May this holy month bring peace, joy, and countless blessings to you and your loved ones.</p>
                    <p><a href='https://www.facebook.com/hashtag/mytsoftdevsolutions' target='_blank' className='blog-link'>
                        #MYTSoftDevSolutions </a>
                        <a href='https://www.facebook.com/hashtag/techforgood' target='_blank' className='blog-link'>
                        #TechForGood </a>
                        <a href='https://www.facebook.com/hashtag/builttolast' target='_blank' className='blog-link'>
                        #BuildToLast </a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Blog67;
